module.exports = __webpack_public_path__ + "img/pjykp.c60c7ed9.png";